import {differenceInDays} from 'date-fns';

import {isEmpty, isNil} from 'ramda';

import {parseDate} from 'shared/web';

import {PriceReportType} from '../types/PriceReportType';

export function isSoldIn90Days(
  priceReport: PriceReportType,
  car: {is_sold: boolean | null; last_occurrence: string | null}
) {
  if (isNil(car.last_occurrence) || isEmpty(car.last_occurrence)) {
    return false;
  }
  return (
    !!car.is_sold &&
    differenceInDays(parseDate(priceReport.created), parseDate(car.last_occurrence)) > 30
  );
}
